// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"suppliersListItem_subtitle__3wgkQ","title":"suppliersListItem_title__3CMi1"};